import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function HabitsGoDeeper() {
  return (
    <div>
      <Formatted className="medium-spacing">
        <Video.Video src={config.videos.identity.habits2} />
        <p>Most human behavior and routines become habits after 21 days of continuous practice.</p>
        <p>Are you ready to try something new? For 21 days or a month? This exercise is about supporting you in making a positive habit change. First of all, look over the list of habits you would like to adopt. Which one feels doable, or important, or scary, or exciting? Which one is calling out to you? Be as specific as you can about what you are doing.</p>
        <p>Once you have chosen a habit you want to incorporate into your life, tell someone! A friend, a partner, your coach, your therapist. Sharing will make your commitment more real. Pick a start date and an end date for this exercise. This will give you a structure and a clear goal. Also, (and here's the fun part) pick a way to reward yourself when you complete this exercise. How do you want to celebrate yourself? This is an important component of your process, so don't skip it!</p>
        <p>You may find at the end that your new habit has improved your life. Congratulations! You may also find that the habit didn't have the benefit you expected. Congratulate yourself on being open to that outcome and decide where to go next.</p>
      </Formatted>
    </div>
  );
}
